import {SquarePenIcon} from 'lucide-react';
import {Button, Tooltip, TooltipContent, TooltipTrigger} from '@tinct/web-components';
import {Link, To} from 'react-router-dom';
import {Brand} from "@tinct/core-api-models";
import {NEW_CAMPAIGN_DIALOG_HASH} from '@tinct/web-feature-campaigns';

interface WelcomeBannerProps {
  firstName?: string | null;
  lastBrandVersion?: Brand | null;
  workspaceBaseUrl: string;
  assetsUrl: string;
}

export function WelcomeBanner({firstName, lastBrandVersion, workspaceBaseUrl, assetsUrl}: WelcomeBannerProps) {
  const isBrandAnalysisDone = lastBrandVersion?.name || lastBrandVersion?.valueAndMessaging;

  const cta: {label: string; link: To} = isBrandAnalysisDone ? {
    label: 'Launch your first campaign',
    link: {hash: NEW_CAMPAIGN_DIALOG_HASH}
  } : {
    label: 'Run brand analysis',
    link: `${workspaceBaseUrl}/brand`
  }

  return (
    <div className="relative flex items-center overflow-hidden rounded-2xl border bg-primary p-10 lg:p-16">
      <div className="relative z-10 flex max-w-md flex-col gap-6">
        <h2
          className="font-heading text-4xl font-semibold leading-tight tracking-tight text-primary-foreground">
          Welcome{firstName ? ` ${firstName}` : ''}!
          <br/>
          This is where the magic happens.
        </h2>
        <p className="text-base text-primary-foreground/80">
          It only takes a few steps to go live. We'll guide you through it.
        </p>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="w-fit">
              <Button variant="outline" className="w-fit bg-white px-3">
                <Link to={cta.link} className={'flex items-center justify-center gap-2 m-0 p-0'}>
                  <SquarePenIcon className="size-4"/>
                  {cta.label}
                </Link>
              </Button>
            </span>
          </TooltipTrigger>
          {!isBrandAnalysisDone && (
            <TooltipContent side={"right"}  className="bg-white text-foreground" arrowClassName="bg-white fill-white">
              Complete your brand analysis first
            </TooltipContent>
          )}
        </Tooltip>
      </div>
      <img
        src={`${assetsUrl}/welcome-mascot.png`}
        alt=""
        className="pointer-events-none absolute -bottom-20 right-0 hidden h-[140%] w-auto object-contain md:block"
      />
    </div>
  );
}
